import { Component, EventEmitter, Inject, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { map, Observable, startWith } from 'rxjs';
import { AttendanceService } from '../attendance.service';
import { AlertComponent } from '../../course-Master/course-fee/alert/alert.component';
import moment from 'moment';
import { ToastmessageService } from 'src/app/toastmessage.service';
import { MatSelect } from '@angular/material/select';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-filterdialog',
  templateUrl: './filterdialog.component.html',
  styleUrls: ['./filterdialog.component.scss']
})
export class FilterdialogComponent {
  main: any;
  addFilter: any;
  // filterCount: any = 0;
  buildingId: any;
  buildingName: any;
  classlist: any;
  classOptions: any;
  classId: any;
  className: any;
  streamlist: any;
  streamOptions: any;
  sectionId: any;
  sectionName: any;
  programlist: any;
  programOptions: any;
  programId: any;
  programName: any;
  // examprogramlist: any;
  // examprogramOptions: any;
  streamName: any;
  sectionlist: any;
  sectionOptions: any;
  // ExamprogramName: any;
  addFilterDisplay: string = 'none';
  stateId: any;
  stateName: any;
  citylist: any;
  cityOptions: Observable<any[]>;
  cityId: any;
  cityName: any;
  campuslist: any;
  campusOptions: Observable<any[]>;
  campusId: any;
  campusName: any;
  buildinglist: any;
  // buildingOptions: any;
  buildingOptions: Observable<any[]> = new Observable();
  State: any;
  finalFilterdata: any;
  filterContainerdisplay: string = 'none';
  columnContainerdiaplay: string = 'none';
  filter: any;
  list: any;
  statelist: any;
  stateOptions: Observable<any[]>;
  general: any = 'none'
  advanced: any = 'none'
  columns: any = 'none'
  selected: any;
  columnCheckBox: any;
  today: Date = new Date();
  minFromDate: Date | null = null;
  maxFromDate: Date | null = this.today;
  minToDate: Date | null = null;
  maxToDate: Date | null = this.today;

  selectedValue: any;
  selectedSection: any = ''

  private class="&classId="
  private stream="&streamId="
  private section="&sectionId="
  private program="&programId="
  private filterBy="&filterBy=";
  private examProgramID="&examProgramId="
  private building="&buildingId="
  @ViewChild('buildingSelect') buildingSelect: MatSelect;
  fb: FormBuilder = new FormBuilder();
  Columns: any[] = [
    {
      "name": "State"
    },
    {
      "name": "City"
    },

    {
      "name": "Name"
    },
    {
      "name": "Campus"
    },
    {
      "name": "Building"
    },
    {
      "name": "Stream"
    },
    {
      "name": "Grade"
    },
    {
      "name": "Section"
    },
    {
      "name": "Program"
    },
    {
      "name": "ExamProgram"
    },
    {
      "name": "Adm.No"
    },
    {
      "name": "Attendence"
    },]
  firstHalf: any[] = [];
  secondHalf: any[] = [];
  @Output() counseback = new EventEmitter
  data1: any;
  duration: any = "3px solid #0564B1";
  durationContainerDisplay: string = "flex";
  applyContainerDisplay: any = "none";
  startDate: any;
  endDate:any;
  start: FormControl<Date | null> = new FormControl<Date | null>(null); // Initialize with null
  end: FormControl<Date | null> = new FormControl<Date | null>(null); 
 
  value: string;
  streamId: any;
  examProgramId: any;
  defaultValues: any;
  stateId1: any;
  cityId1: any;
  name: string;
  classname: string;
  streamname: string;
  programname: string;
  sectionname: string;
  builddatalist: any;
  count: any = 0;
  buildingClick: any = 0;
  classClick: any = 0;
  streamClick: any = 0;
  sectionbuildingClick: any = 0;
  programClick: any=0;
  classdata: any;
  streamdata: any;
  programdata: any;
  sectiondata: any;
  Sectioncount: any=0;
  programcount:  any=0;
  streamcount: any=0;
  classcount: any=0;
  options: any;
  loading: boolean=true;
  constructor(private http:AttendanceService,private dialog:MatDialog, @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<FilterdialogComponent> ,private toast:ToastmessageService,private spinner: NgxSpinnerService,) { }
  ngOnInit(): void {
     
    this.minFromDate = null;
    this.minToDate = null;
    if (this.data) {
      this.selectedValue = this.data.values || 'lastweek'; 
      this.start.setValue(this.data.stardate1 ? new Date(this.data.stardate1) : null);
      this.end.setValue(this.data.enddate1 ? new Date(this.data.enddate1) : null);
    } else {
      this.selectedValue = 'lastweek';
      const today = new Date();
      const defaultStartDate = new Date(today.setDate(today.getDate() - 7)); 
      this.start.setValue(defaultStartDate); 
      this.end.setValue(this.today); 
    }
    if (this.start.value) {
      this.minToDate = this.start.value;
    }
    if (this.end.value) {
      this.maxFromDate = this.end.value;
    }
    this.changeFilter()
    this.main = new FormGroup({
      "StateControl": new FormControl(),
      "CityControl": new FormControl(),
      "CampusControl": new FormControl(),
      "CityControl2": new FormControl(),
      "CampusControl2": new FormControl(),
      "StateControl2": new FormControl(),
    })
    this.addFilter = new FormGroup({
      "BuildingControl": new FormControl(),
      "BuildingControl2": new FormControl(),
      "ClassControl": new FormControl(),
      "ClassControl2": new FormControl(),
      "ProgramControl": new FormControl(),
      "JoinYearControl": new FormControl(),
      "StreamControl": new FormControl(),
      // "BatchControl":new FormControl(),
      "ProgramControl2": new FormControl(),
      // "BatchControl2":new FormControl(),
      "JoinYearControl2": new FormControl(),
      "StreamControl2": new FormControl(),
      "SectionControl": new FormControl(),
      "SectionControl2": new FormControl(),

    })
    console.log(this.Columns)
    this.firstHalf = this.Columns.slice(0, Math.ceil(this.Columns.length / 2))
    this.secondHalf = this.Columns.slice(Math.ceil(this.Columns.length / 2))

    this.openNav()
    this.http.getdefultstate().subscribe((res: any) => {
      this.statelist = res
      this.defaultValues = res.defaultValues

      this.stateId1 = this.defaultValues.stateId
      this.cityId1 = this.defaultValues.cityId
      this.campusId = this.defaultValues.campusId
      this.main.patchValue({
        // StateControl: this.defaultValues.stateId,
        CityControl: this.defaultValues.cityName,
        CampusControl: this.defaultValues.campusName,
        StateControl: this.defaultValues.stateName,

        // StateControl2:this. defaultValues.
      });
      this.stateOptions = this.main.get('StateControl2').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.Filter(value, this.statelist.stateList, 'stateName'))
      );
      if (this.stateId1) {
        this.http.getCity(this.stateId1).subscribe((res: any) => {
          this.citylist = res;
          this.cityOptions = this.main.get('CityControl2').valueChanges.pipe(
            startWith(''),
            map((value: any) => this.Filter(value, this.citylist, 'cityName'))
          );
        });
      }
      if (this.cityId1) {
 
        this.http.getCampus(this.cityId1).subscribe((res: any) => {
          this.campuslist = res
          this.campusOptions = this.main.get('CampusControl2').valueChanges.pipe(
            startWith(''),
            map((value: any) => this.Filter(value, this.campuslist, 'campusName'))
          );
        })
      }
    })
  }

  handleStateSelection(item: any) {
    this.getCity(item);
    this.clearCity();
  }
  clearCampus() {
    this.main.get('CampusControl').reset()
    this.clearBuilding()
  }
  clearCity() {
    this.main.get('CityControl').reset()

    this.clearCampus()
  }
  clearBuilding() {
    this.addFilter.get('BuildingControl').reset()
    this.buildingClick=0;
    this.clearClass();
  }


  getClass(item: any) {
    // this.filterCount = 4;
    this.buildingId = item.Id
    this.buildingClick++;
  }

  getStream(item: any) {
    // this.filterCount = 5;
    this.classId = item.Id
    this.className = item.Name;
    this.classClick++
  }
  getProgram(item: any) {
    // this.filterCount = 7;
    this.streamId = item.Id
    this.sectionId = item.sectionId
    this.sectionName = item.sectionName
    this.streamClick++
    
  }
  
  getExamProgram(item: any) {
   
    this.sectionId = item.Id
    this.sectionbuildingClick++

    
  }

  getSection(item: any) {
    // this.filterCount = 6;
    this.programId = item.Id
    // this.streamId = item.sreamId
    this.streamName = item.streamName
    this.programClick++
  
  }
  getExamprogram(item: any) {
    // this.filterCount = 9;
    // this.ExamprogramName = item.ExamprogramName;
    this.examProgramId = item.examProgramId
  }
  clear() {
    this.addFilterDisplay = 'none';
    this.clearClass();
  }

  getCity(state: any) {
    // this.filterCount = 1;
    this.stateId = state.stateId
    this.stateName = state.stateName
    this.http.getCity(this.stateId).subscribe((res: any) => {
      this.citylist = res
      this.cityOptions = this.main.get('CityControl2').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.Filter(value, this.citylist, 'cityName'))
      );
    })
  }
  getCampus(city: any) {
    // this.filterCount = 2;
    this.cityId = city.cityId
    this.cityName = city.cityName
    this.http.getCampus(this.cityId).subscribe((res: any) => {
      this.campuslist = res
      this.campusOptions = this.main.get('CampusControl2').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.Filter(value, this.campuslist, 'campusName'))
      );
    })
  }
  getBuildings(campus: any) {
    // this.filterCount = 3;
    this.campusId = campus.campusId
    this.campusName = campus.campusName
    this.http.getbuildings(this.campusId).subscribe((res: any) => {
      this.buildinglist = res
      this.buildingOptions = this.main.get('BuildingControl2').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.Filter(value, this.buildinglist, 'buildingName'))
      );
    })

  }
  getCampusID(campus: any) {
    this.campusId = campus.campusId
    this.count = 0;
  }

  private Filter(value: string, list: any[], name: any): any[] {
    const searchValue = value.trim().toLocaleLowerCase();
    let filteredList = list.filter((item: any) => item[name] && item[name].toString().trim().toLocaleLowerCase().includes(searchValue));
    // console.log(filteredList)
    return filteredList;
  }

  openedChange(isOpen:boolean){
    if(!isOpen){
      this.loading = true;
    }
  }
  getdymaic() {
    this.loading = true;
    this.name = "Building"
    // this.filterCount = 3;
    // this.buildingClick++;
    this.http.getfilterlist(this.createUrl("Building"), this.name).subscribe(res => {
      this.loading = false;
      this.buildinglist = res
      this.buildingOptions = this.addFilter.get('BuildingControl2').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.Filter(value, this.buildinglist, 'Name'))
      );
      console.log("name", this.buildinglist);
      console.log('BUILDING', this.buildingOptions);
      // this.apiCalled = true;
      if (this.buildingSelect) {
        // this.buildingSelect.open();
      } else {
        console.warn('MatSelect is not available at the time of API call.');
      }
    })
  }
  dymaicclasslist() {
    this.loading=true
    this.classname = "Class"
    // this.classClick++;
    console.log(this.buildingId);
    this.http.getfilterlist(this.createUrl("Class"), this.classname).subscribe(res => {
      this.classlist = res
      this.loading=false
      this.classOptions = this.addFilter.get('ClassControl2').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.Filter(value, this.classlist, 'Name'))
      );
      // this.apiCalled = true;
    })
  }
  dymaicstream() {
    this.loading=true
    this.streamname = "Stream"
    // this.streamClick++
    this.http.getfilterlist(this.createUrl("Stream"), this.streamname).subscribe(res => {
      this.streamlist = res
      this.loading=false
      this.streamOptions = this.addFilter.get('StreamControl2').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.Filter(value, this.streamlist, 'Name'))
      );
      // this.apiCalled = true;
    })
  }
  dymaicprogram() {
    this.loading=true
    this.programname = "Program"
    // this.programClick++
    this.http.getfilterlist(this.createUrl("Program"), this.programname).subscribe(res => {
      this.programlist = res
      this.loading=false
      this.programOptions = this.addFilter.get('ProgramControl2').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.Filter(value, this.programlist, 'Name'))
      );
      // this.apiCalled = true;
    })
  }
  dymaicsesction() {
    this.loading=true
    this.sectionname = "Section"
    this.http.getfilterlist(this.createUrl("Section"), this.sectionname).subscribe(res =>{
      this.sectionlist = res
      this.loading=false
      this.sectionOptions = this.addFilter.get('SectionControl2').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.Filter(value, this.sectionlist, 'Name'))
      );
      // this.apiCalled = true;
    })
  }
  fetchOptions(){
    this.sectionname = "Section"
    if (!this.sectionlist) {
      console.warn("sectionlist is undefined or null!");
      this.sectionlist = [];
    }
    if (this.sectionlist.length > 0) {
     
    }
    this.loading = true;
    this.http.getfilterlist(this.createUrl("Section"), this.sectionname).subscribe(res =>{
      this.sectionlist = res
    })
  }
  filterdialog() {
    if (this.State != 'none') {
      this.finalFilterdata = 'flex';
    }

  }
  closefilter() {
    this.filterContainerdisplay = 'none'
  }
  searchfilter() {
    this.changeFilter()
    if (this.stateId1 != null) {
      if (this.cityId1 != null) {
        if (this.campusId != null) {
      
        this.closeNav()
        }else {
          const data = "Please Select Campus "
          this.dialog.open(AlertComponent, {
            width: '800px',
            position: { right: '20px', top: '20px' },
            data: { data }
          })
        }
      }
      else {
        const data = "Please Select City "
        this.dialog.open(AlertComponent, {
          width: '800px',
          position: { right: '20px', top: '20px' },
          data: { data }
        })
      }
    }
    else {
      const data = "Please Select State "
      this.dialog.open(AlertComponent, {
        width: '800px',
        position: { right: '20px', top: '20px' },
        data: { data }
      })
    }
  }
  clearClass() {
    this.addFilter.get("ClassControl").reset()
    this.classClick=0;
    this.classcount=0;
    this.clearStream()
  }
  clearStream() {
    this.addFilter.get("StreamControl").reset()
    this.streamClick=0;
    this.Sectioncount=0;
    this.clearProgram()
  }
  clearSection() {
    this.addFilter.get("SectionControl").reset()
    this.sectionbuildingClick=0;
    this.Sectioncount=0;
    this.clearExamProgram()
  }
  clearProgram() {
    this.addFilter.get("ProgramControl").reset()
    this.programClick=0;
    this.programcount=0;
    this.clearSection()
  }
  clearExamProgram() {
    this.addFilter.get("JoinYearControl").reset()
  }
  clearAll() {

    this.main.get("StateControl").reset()

    this.clearCity()
    // this.filterCount = 0
    this.changeFilter()
    this.closeNav()
  }
  clearData(name: string) {
    (this as any)[name] = 'none';
  }
  clearAllData() {
    this.clearAll()
  }

  openNav() {
    this.duration = "3px solid #0564B1";
  }
  closeNav() {
    const data = {
      // "filterCount": this.filterCount,
      "campusId":this.campusId,
      "buildingId": this.buildingId,
      "classId": this.classId,
      "streamId": this.streamId,
      "sectionId": this.sectionId,
      "programId": this.programId,
      "examProgramId": this.examProgramId,
      "count": 0,
      "data": this.selectedValue ? this.selectedValue : this.data1,
      startDate: moment(this.start.value).format('DD-MMM-YYYY'),
      endDate: moment(this.end.value).format('DD-MMM-YYYY')
    }
    this.dialogRef.close(data)
    this.duration = "3px solid #0564B1";
    this.applyContainerDisplay = "none"
    this.general = "none";
    this.advanced = "none";
    this.columns = "none";
  }
  close() {
    this.dialogRef.close()
  }
  border(item: any) {

    if (item == 'duration') {
      this.duration = "3px solid #0564B1";
      this.general = "none";
      this.advanced = "none";
      this.columns = "none";
      this.applyContainerDisplay = "none"
      this.durationContainerDisplay = "flex"
      this.filterContainerdisplay = 'none'
      this.addFilterDisplay = 'none'
      this.columnContainerdiaplay = 'none'

    }
    else if (item == 'general') {
      this.general = "3px solid #0564B1";
      this.duration = "none"
      this.advanced = "none";
      this.columns = "none";
      this.durationContainerDisplay = "none"
      this.filterContainerdisplay = 'flex'
      this.applyContainerDisplay = "flex"
      this.addFilterDisplay = 'none'
      this.columnContainerdiaplay = 'none'
    }
    else if (item == 'advanced') {

      this.general = "none";
      this.advanced = "3px solid #0564B1";
      this.columns = "none";
      this.duration = "none"
      this.durationContainerDisplay = "none"
      this.applyContainerDisplay = "flex"
      this.filterContainerdisplay = 'none'
      this.addFilterDisplay = 'flex'
      this.columnContainerdiaplay = 'none'

    }
    else if (item == 'columns') {
      this.general = "none";
      this.columns = "3px solid #0564B1";
      this.advanced = "none";
      this.duration = "none"
      this.durationContainerDisplay = "none"
      this.applyContainerDisplay = "flex"
      this.filterContainerdisplay = 'none'
      this.addFilterDisplay = 'none'
      this.columnContainerdiaplay = 'flex'
    }
  }
  onBehaviurSelect(e: any) {
    console.log('Selected value:', this.selectedValue); 
    const input = e.target as HTMLInputElement;
    this.selectedValue = input.value;
    console.log('Selected value:', this.selectedValue);
    this.data1 = this.selectedValue;
    console.log("data1:", this.data1);
    if (['Today', 'Yesterday', 'lastweek', 'lastmonth', 'last3months', 'last6months'].includes(this.selectedValue)) {
      this.start.setValue(null);
      this.end.setValue(null);

      this.start.disable();
      this.end.disable();
    } else {

      this.start.enable();
      this.end.enable();
    }
  }
  clearRadioButtons() {
    this.selectedValue = '';  
   
  }
  apply() {
    if ((this.start?.value !== null && this.end?.value !== null) || this.selectedValue) {
      this.general = "3px solid #0564B1";
      this.duration = "none"
      this.advanced = "none";
      this.columns = "none";
      this.durationContainerDisplay = "none"
      this.filterContainerdisplay = 'flex'
      this.applyContainerDisplay = "flex"
      this.addFilterDisplay = 'none'
      this.columnContainerdiaplay = 'none'
    } else {
      this.toast.showError("Please Selected the Start and end Date")
    }
  }
  changeFilter() {
    // if (this.filterCount != 0) {
    //   this.filter = `Filter(${this.filterCount})`;
    // }
    // else {
    //   this.filter = `Filter`
    // }
  }
  // fromDateChange(type: string, event: any) {
  //   console.log(`${type}: ${event.value}`);
  //   this.minToDate = event.value;
  //   this.data1 = "betweendates";
  
  //   if (event.value !== null) {
  //     const m: any = new Date(event.value._d);
  //     this.maxToDate = new Date(m.getFullYear(), m.getMonth(), m.getDate() + 30);
  //     if (this.maxToDate > this.today) {
  //       this.maxToDate = this.today;
  //     }
  //     this.start.setValue(event.value); 
  //   }
  // }
  
  // toDateChange(type: string, event: any) {
  //   this.maxFromDate = event.value;
  //   this.data1 = "betweendates";
  
  //   if (event.value !== null) {
  //     const m: any = new Date(event.value._d);
  //     this.minFromDate = new Date(m.getFullYear(), m.getMonth(), m.getDate() - 30);
  
  //     // Set the value for end date form control
  //     this.end.setValue(event.value); // Set value in FormControl
  //   }
  // }
  
  handleDateChange(type: 'start' | 'end', event: any) {
    if (type === 'start') {
   
      console.log(`Start Date: ${event.value}`);
      this.minToDate = event.value; 
      this.data1 = "betweendates";
  
      if (event.value !== null) {
        const selectedStartDate = new Date(event.value);
        const maxDateLimit = new Date(selectedStartDate.getFullYear(), selectedStartDate.getMonth(), selectedStartDate.getDate() + 30);
        this.maxToDate = maxDateLimit > this.today ? this.today : maxDateLimit;
        // if (this.end.value) {
        //   this.end.setValue(null);
        // }
        if (this.start.value !== event.value) {
          this.start.setValue(event.value);
        }
      }
    } else if (type === 'end') {
  
      console.log(`End Date: ${event.value}`);
      this.maxFromDate = event.value; 
      this.data1 = "betweendates";
  
      if (event.value !== null) {
        const selectedEndDate = new Date(event.value);
        const minDateLimit = new Date(selectedEndDate.getFullYear(), selectedEndDate.getMonth(), selectedEndDate.getDate() - 30);
        this.minFromDate = minDateLimit;
        if (this.end.value !== event.value) {
          this.end.setValue(event.value);
        }
      }
    }
    this.clearRadioButtons();
  }
  builddata(url:any) {
    this.name = 'Building'
    if (this.count == 0) {
      this.http.getfilterlist(url, this.name).subscribe(res => {
        this.spinner.show()
        this.builddatalist = res
        this.count++;
        this.spinner.hide()
      })
      console.log(this.builddatalist);
    }
    this.spinner.hide()
  }
  classdatalist(url:any){
     this.name = 'Class'
    if (this.classcount == 0) {
      this.http.getfilterlist(url, this.name).subscribe(res => {
        this.spinner.show()
        this.classdata = res
        this.classcount++;
        this.spinner.hide()
      })
      console.log(this.classdata);
    }
    this.spinner.hide()
  }
  streamdatalist(url:any){
     this.name = 'Stream'
    if (this.streamcount == 0) {
      this.http.getfilterlist(url, this.name).subscribe(res => {
        this.spinner.show()
        this.streamdata = res
        this.streamcount++;
        this.spinner.hide()
      })
      console.log(this.streamdata);
    }
    this.spinner.hide()
  }
  programdatalist(url:any){
     this.name = 'Program'
    if (this.programcount == 0) {
      this.http.getfilterlist(url, this.name).subscribe(res => {
        this.spinner.show()
        this.programdata = res
        this.programcount++;
        this.spinner.hide()
      })
      console.log(this.programdata);
    }
    this.spinner.hide()
  }
  sectiondatalist(url:any){
     this.name = 'Section'
    if (this.Sectioncount == 0) {
      this.http.getfilterlist(url, this.name).subscribe(res => {
        this.spinner.show()
        this.sectiondata = res
        this.Sectioncount++;
        this.spinner.hide()
      })
      console.log(this.sectiondata);
    }
    this.spinner.hide()
  }
 
  onbuildingClick() {
    this.builddata(this.createUrl("Building"));
  }
  onClassClick(){
 this.classdatalist(this.createUrl("Class"))
  }
  onStreamClick(){
    this.streamdatalist(this.createUrl("Stream"))
  }
  onProgramClick(){
    this.programdatalist(this.createUrl("Program"))
  }
  onSectionClick(){
    this.sectiondatalist(this.createUrl("Section"))
  }
getExamProgram1(e: any) {
    this.sectionId = e.target.value;
    this.sectiondatalist(this.createUrl("Section"))
    console.log("Selected Section ID:", this.sectionId);
}
createUrl(name:any){
  
  let url="https://testmasters.scaits.net/employee/api/jwtV2/student/weeklyAttendance/filterDetails?campusId="+this.campusId;

  if(this.buildingClick!=0 && name!="Building"){
    url = url+this.building+this.buildingId
  }
  
  if(this.classClick!=0 && name!="Building" && name!="Class"){
    url = url+this.class+this.classId
  }
  
  if(this.streamClick!=0 && name!="Building" && name!="Class" && name!="Stream" ){
    url = url+this.stream+this.streamId
  }
  if(this.programClick!=0&&name!="Building" && name!="Class" && name!="Stream" && name!="Program" ){
    url=url+this.program+this.programId
  }
  url = url+this.filterBy

  return url;
}
}

